"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromJSONAnyOfAttr = void 0;
const index_js_1 = require("../../../../attributes/anyOf/index.js");
const options_js_1 = require("../../../../attributes/anyOf/options.js");
const attribute_js_1 = require("./attribute.js");
/**
 * @debt feature "handle defaults, links & validators"
 */
const fromJSONAnyOfAttr = ({ elements, ...props }) => {
    /**
     * @debt types "fix those casts"
     */
    let $attr = (0, index_js_1.anyOf)(...elements.map(attribute_js_1.fromAttrDTO));
    const { required, hidden, key, savedAs, defaults, links } = props;
    defaults;
    links;
    if (required !== undefined && required !== options_js_1.ANY_OF_DEFAULT_OPTIONS.required) {
        $attr = $attr.required(required);
    }
    if (hidden !== undefined && hidden !== options_js_1.ANY_OF_DEFAULT_OPTIONS.hidden) {
        $attr = $attr.hidden(hidden);
    }
    if (key !== undefined && key !== options_js_1.ANY_OF_DEFAULT_OPTIONS.key) {
        $attr = $attr.key(key);
    }
    if (savedAs !== undefined && savedAs !== options_js_1.ANY_OF_DEFAULT_OPTIONS.savedAs) {
        $attr = $attr.savedAs(savedAs);
    }
    return $attr;
};
exports.fromJSONAnyOfAttr = fromJSONAnyOfAttr;
